<app-error-banner />
@if (!isAppEmbedded) {
  <app-header />
}
<main class="main-wrapper" [ngClass]="{'embed': isAppEmbedded}">
  <router-outlet></router-outlet>
  <app-loading-spinner></app-loading-spinner>
</main>
@if (!isAppEmbedded) {
  <app-footer />
}
